import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    displayableCashback,
    hasCashback,
    isMultiDiscount,
    renderPluralConditional
} from '../../services/partner/utils';

class CashbackBlocPartenaireComponent extends React.Component {
    pluralCondFunc = mdd => (mdd && mdd.fixed > 1) || mdd.percent > 1;

    renderJusqua = (partner, i18n) =>
        isMultiDiscount(partner) && <div className="jusqua small">{i18n.jusqua}</div>;

    renderDisplayCashback = mostDisplayableDiscountOnline => (
        <strong>
            {`${displayableCashback(
                mostDisplayableDiscountOnline.percent,
                mostDisplayableDiscountOnline.fixed
            )} `}
        </strong>
    );

    renderInsteadOf = (mdd, i18n) =>
        !!mdd &&
        (mdd.initialPercent > 0 || mdd.initialFixed > 0) && (
            <div className="small aulieu">
                {`${i18n.aulieude} ${displayableCashback(mdd.initialPercent, mdd.initialFixed)}`}
            </div>
        );

    renderNoCashback = (i18n, cssClassContainer) => (
        <div className={`${cssClassContainer} flex-container-v`}>
            <div className="small nocashback">{i18n.pasdecashbackencemoment}</div>
        </div>
    );

    renderConditional = (partner, i18n, cssClassContainer, discount) => {
        if (partner && hasCashback(partner)) {
            const { id, mostDisplayableDiscountOnline } = partner;
            const mostDisplayableDiscount =
                discount && discount.partnerId === id
                    ? discount.cashback
                    : mostDisplayableDiscountOnline;

            return (
                <div className={`${cssClassContainer} flex-container-v`}>
                    {this.renderJusqua(partner, i18n)}
                    <div className="valeur">
                        {this.renderDisplayCashback(mostDisplayableDiscount)}
                        {renderPluralConditional(i18n.rembourse, () =>
                            this.pluralCondFunc(mostDisplayableDiscount)
                        )}
                    </div>
                    {this.renderInsteadOf(mostDisplayableDiscount, i18n)}
                </div>
            );
        } else {
            return this.renderNoCashback(i18n, cssClassContainer);
        }
    };

    render() {
        const { i18n, partner, cssClassContainer, discount } = this.props;
        return this.renderConditional(partner, i18n, cssClassContainer, discount);
    }
}

CashbackBlocPartenaireComponent.propTypes = {
    partner: PropTypes.object.isRequired,
    i18n: PropTypes.object.isRequired,
    cssClassContainer: PropTypes.string.isRequired,
    discount: PropTypes.object
};

const mapStateToProps = state => ({
    i18n: state.i18n.feature.partenaire
});

export default connect(mapStateToProps)(CashbackBlocPartenaireComponent);



// WEBPACK FOOTER //
// ./src/components/partner/CashbackBlocPartenaireComponent.js